<template>
  <div class="box box-success">
    <div class="box-body">
      <div class="col-md-12" style="margin-top: 15px">
        <div style="margin-bottom: 10px">
          <label for="">{{ $t("product.title") }}</label>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                v-model="searchData.searchText"
                :placeholder="$t('search.title')"
                @input="onFiltered(searchData.searchText)"
              />
            </div>
            <div>
              <b-table
                striped
                hover
                :sticky-header="`${screenHight}px`"
                :items="productItems"
                :fields="productFields"
              >
                <template #head()="scope">
                  <div class="">{{ $t(scope.label) }}</div>
                </template>
                <template #cell(actions)="row">
                  <button
                    class="btn btn-primary btn-sm"
                    style="margin-left: 6px;"
                    @click="onOpenEditProductInApartment(row.item)"
                  >
                    <i class="glyphicon glyphicon-plus"></i>
                  </button>
                </template>
              </b-table>
            </div>
          </div>
          <div class="col-sm-12 col-md-8">
            <div class="form-group">
              <v-select
                class="clear"
                :options="apartmentTypeList"
                :reduce="data => data.value"
                :getOptionLabel="option => $t(option.text)"
                v-model="apartmentTypeId"
                :placeholder="$t('apartmentType.title')"
                @option:selected="onChangeApartment(apartmentTypeId)"
              >
                <template v-slot:option="option">
                  {{ option.text }}
                </template>
              </v-select>
            </div>
            <div>
              <b-table
                striped
                hover
                :sticky-header="`${screenHight}px`"
                :items="productInApartmentTypeItems"
                :fields="productInApartmentTypeFields"
              >
                <template #head()="scope">
                  <div class="">{{ $t(scope.label) }}</div>
                </template>
                <template #cell(productPrice)="row">
                  {{ currencyFormat(row.item.productPrice) }}
                </template>
                <template #cell(totalFee)="row">
                  {{ currencyFormat(row.item.totalFee) }}
                </template>
                <template #cell(actions)="row">
                  <div class="btn-group">
                    <button
                      type="button"
                      class="btn btn-danger dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="true"
                    >
                      <i class="fa fa-fw fa-ellipsis-h"></i>
                    </button>
                    <ul class="dropdown-menu" style="min-width: 50px">
                      <li>
                        <button
                          v-if="
                            GET_ACCOUNT_DATA.id == 1 ||
                              has_perm('update_apartment')
                          "
                          class="btn btn-primary btn-sm"
                          style="margin-left: 6px;"
                          @click="onOpenEditInput(row.item)"
                        >
                          <i class="glyphicon glyphicon-edit"></i>
                        </button>
                      </li>
                      <li style="margin-top: 5px">
                        <button
                          v-if="
                            GET_ACCOUNT_DATA.id == 1 ||
                              has_perm('delete_apartment')
                          "
                          class="btn btn-danger btn-sm"
                          style="margin-left: 6px;"
                          @click="onOpenDelete(row.item)"
                        >
                          <i class="glyphicon glyphicon-trash"></i>
                        </button>
                      </li>
                    </ul>
                  </div>
                </template>
              </b-table>
              <div v-if="productInApartmentTypeItems.length" class="box-footer clearfix" style="display:contents;">
                <custom-paginator
                  :totalItem="paginateData.totalItem"
                  :currentPage="paginateData.currentPage"
                  :pageSize="paginateData.pageSize"
                  :totalPage="paginateData.totalPage"
                  @onpaginate="onCustomPagination"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div
      class="modal fade"
      :ref="`modal-add-product-in-apartment-type`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("serviceAndProductInApartment.addProductInApartment") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("product.productList.productName")
                  }}</label>
                  <span class="form-control product-info">{{
                    productSelect.productName
                  }}</span>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("product.productList.productCode")
                  }}</label>
                  <span class="form-control product-info">{{
                    productSelect.productCode
                  }}</span>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("product.productUnit") }}</label>
                  <span class="form-control product-info">{{
                    productSelect.productUnit
                  }}</span>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("product.productList.productPrice")
                  }}</label>
                  <span class="form-control product-info">{{
                    currencyFormat(productSelect.productPrice)
                  }}</span>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("serviceAndProductInApartment.quantity")
                  }}</label>
                  <input
                    type="number"
                    v-model="productSelect.productAmount"
                    class="form-control"
                    @input="onChangeProductAmount(productSelect.productAmount)"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("serviceAndProductInApartment.totalFee")
                  }}</label>
                  <span class="form-control product-info">{{
                    currencyFormat(productSelect.totalPrice)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onSaveProduct"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div
      class="modal fade"
      :ref="`modal-update-product-in-apartment-type`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("serviceAndProductInApartment.updateProductInApartment") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("serviceAndProductInApartment.quantity")
                  }}</label>
                  <input
                    type="number"
                    v-model="productInApartmentData.productAmount"
                    class="form-control"
                    @input="
                      onChangeProductAmount(
                        productInApartmentData.productAmount
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onUpdateProduct"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CustomPaginator from "@/components/CustomPaginator.vue";
import LTEModal from "@/components/LTEModal.vue";
import utils from "@/lib/utils";

export default {
  components: {
    "lte-modal": LTEModal,
    CustomPaginator
  },
  props: {
    bookingId: {
      type: Number,
      default: () => {
        return null;
      }
    }
  },
  data: () => ({
    screenHight: 0,
    searchData: {
      searchText: null
    },
    // apaertment
    apartmentTypeId: null,
    // product list
    productFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      // {
      //   key: "productCode",
      //   label: "product.productList.productCode"
      // },
      {
        key: "productName",
        label: "product.productList.productName"
      },
      { key: "actions", label: "common.action" }
    ],
    productListClone: [],
    productItems: [],
    // product select
    productSelect: {
      id: null,
      productName: null,
      productCode: null,
      productUnit: null,
      productPrice: null,
      productAmount: 1,
      totalPrice: 0
    },
    isModalVisible: false,
    originalRecordData: null,
    objModal: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    // product in apartment
    productInApartmentTypeFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "productCode",
        label: "product.productList.productCode"
      },
      {
        key: "productName",
        label: "product.productList.productName"
      },
      {
        key: "quantity",
        label: "serviceAndProductInApartment.quantity"
      },
      {
        key: "productUnit",
        label: "product.productUnit"
      },
      {
        key: "productPrice",
        label: "product.productList.productPrice"
      },

      {
        key: "totalFee",
        label: "serviceAndProductInApartment.totalFee"
      },
      { key: "actions", label: "common.action" }
    ],
    productInApartmentTypeItems: [],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    productInApartmentData: {
      id: null,
      productAmount: null
    },
    apartmentTypeList: []
  }),
  watch: {
    bookingId: function() {},
    GET_PRODUCT_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_PRODUCT_LIST_NO_PAGE_DATA;
      this.productItems = [];
      data.forEach((value, index) => {
        // let nonumber =
        //   index +
        //   1 +
        //   (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let item = {
          id: value.id,
          nonumber: index + 1,
          productCode: value.code,
          productName: value.name,
          // productGroupName: '',
          productGroup: value.product_group,
          // productUnitName: '',
          productUnit: value.product_unit,
          productPrice: value.price,
          productDescription: value.description
        };
        this.productItems.push(item);
      });
      this.productListClone = this.productItems;
    },
    GET_PRODUCT_IN_APARTMENT_TYPE_LIST_DATA: function() {
      let paginate = this.GET_PRODUCT_IN_APARTMENT_TYPE_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.productInApartmentTypeItems = [];
      this.GET_PRODUCT_IN_APARTMENT_TYPE_LIST_DATA.results.forEach((data, i) => {
        let nonumber =
          i +
          1 +
          (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let item = {
          nonumber: nonumber,
          id: data.id,
          productCode: data.product.code,
          productName: data.product.name,
          productUnit: data.product.product_unit,
          quantity: data.amount,
          productPrice: data.unit_price,
          totalFee: data.total_price
        };
        this.productInApartmentTypeItems.push(item);
      });
    },
    GET_APARTMENT_TYPE_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_APARTMENT_TYPE_LIST_NO_PAGE_DATA
      this.apartmentTypeList = []
      data.forEach(value => {
        let item = {
          value: value.id,
          text: value.name
        }
        this.apartmentTypeList.push(item)
      })
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_PRODUCT_LIST_NO_PAGE_DATA",
      "GET_PRODUCT_IN_APARTMENT_TYPE_LIST_DATA",
      "GET_APARTMENT_TYPE_LIST_NO_PAGE_DATA"
    ])
  },
  methods: {
    handleResize() {
      this.screenHight =
        window.innerHeight - 382 > 300 ? window.innerHeight - 382 : 300;
    },
    currencyFormat: function(value) {
      if (!utils.isEmptyString(value)) {
        return utils.formatNumber(value);
      }
      return null;
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onOpenEditInput: function(data) {
      $(this.$refs[`modal-update-product-in-apartment-type`]).modal("show");
      this.productInApartmentData = {
        id: data.id,
        productAmount: parseInt(data.quantity)
      };
    },
    onUpdateProduct: function() {
      if (
        utils.isEmptyString(this.productInApartmentData.productAmount) ||
        this.productInApartmentData.productAmount <= 0
      ) {
        this.showError(this.$t("serviceAndProductInApartment.quantity"));
      } else {
        let data = {
          id: this.productInApartmentData.id,
          amount: parseInt(this.productInApartmentData.productAmount)
        };
        this.UPDATE_PRODUCT_IN_APARTMENT_TYPE(data)
          .then(
            function() {
              $(this.$refs[`modal-update-product-in-apartment-type`]).modal("hide");
              this.getProductInApartmentList(
                this.apartmentTypeId,
                this.paginateData.currentPage
              );
            }.bind(this)
          )
          .catch(function() {}.bind(this));
      }
    },
    // delete
    onOpenDelete: function(data) {
      this.originalRecordData = data;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_PRODUCT_IN_APARTMENT_TYPE(this.originalRecordData)
        .then(
          function() {
            this.getProductInApartmentList(
              this.apartmentTypeId,
              this.paginateData.currentPage
            );
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    getProductList: function() {
      this.GET_PRODUCT_LIST();
    },
    onCustomPagination: function(data) {
      this.paginateData.currentPage = data;
    },
    onFiltered: function(filter) {
      if (filter.length > 0) {
        this.productItems = this.productListClone.filter(x =>
          utils
            .replaceCharactersVNLanguage(x.productName.toLowerCase())
            .includes(filter)
        );
      } else {
        this.productItems = this.productListClone;
      }
    },
    onCallbackData: function() {
      this.getProductList();
    },
    showError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    // add product in apartment
    onShowAddProductModal: function(data) {
      $(this.$refs[`modal-add-product-in-apartment-type`]).modal("show");
    },
    onHideAddProductModal: function(data) {
      $(this.$refs[`modal-add-product-in-apartment-type`]).modal("hide");
    },
    onOpenEditProductInApartment: function(data) {
      this.productSelect.id = data.id;
      this.productSelect.productName = data.productName;
      this.productSelect.productCode = data.productCode;
      this.productSelect.productUnit = data.productUnit.name;
      this.productSelect.productPrice = data.productPrice;
      this.productSelect.productAmount = 1;
      this.productSelect.totalPrice =
        data.productPrice * this.productSelect.productAmount;
      this.onShowAddProductModal();
    },
    onChangeProductAmount: function(data) {
      if (utils.isEmptyString(data) || data <= 0) {
        this.showError(this.$t("serviceAndProductInApartment.quantity"));
      } else {
        this.productSelect.totalPrice =
          this.productSelect.productPrice * this.productSelect.productAmount;
      }
    },
    onSaveProduct: function() {
      if (
        utils.isEmptyString(this.productSelect.productAmount) ||
        this.productSelect.productAmount <= 0
      ) {
        this.showError(this.$t("serviceAndProductInApartment.quantity"));
      } else if (utils.isEmptyString(this.apartmentTypeId)) {
        this.showError(this.$t("apartmentType.title"));
      } else {
        let data = {
          apartmentTypeId: this.apartmentTypeId,
          product: this.productSelect.id,
          unit_price: this.productSelect.productPrice,
          amount: this.productSelect.productAmount,
          total_price: this.productSelect.totalPrice
        };
        this.ADD_PRODUCT_IN_APARTMENT_TYPE(data)
          .then(
            function() {
              this.onHideAddProductModal();
              this.getProductInApartmentList(
                this.apartmentTypeId,
                this.paginateData.currentPage
              );
            }.bind(this)
          )
          .catch(function() {}.bind(this));
      }
    },
    getProductInApartmentList: function(apartmentTypeId, page) {
      let filter = {
        params: {
          apartmentTypeId: apartmentTypeId,
          page: page
        }
      };
      this.GET_PRODUCT_IN_APARTMENT_TYPE_LIST(filter);
    },
    onChangeApartment: function(data) {
      this.getProductInApartmentList(data, 1);
    },
    getApartmentTypeList: function() {
      this.isLoading = true;
      this.GET_APARTMENT_TYPE_LIST()
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    getSearchData: function() {
      this.getApartmentTypeList()
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_PRODUCT_LIST",
      "GET_PRODUCT_IN_APARTMENT_TYPE_LIST",
      "ADD_PRODUCT_IN_APARTMENT_TYPE",
      "UPDATE_PRODUCT_IN_APARTMENT_TYPE",
      "DELETE_PRODUCT_IN_APARTMENT_TYPE",
      "GET_APARTMENT_TYPE_LIST"
    ])
  },
  async mounted() {
    await this.getProductList();
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }
};
</script>
<style scoped>
.asset-img-class {
  width: 100%;
  max-width: 75px;
  max-height: 100px;
  object-fit: contain;
  cursor: pointer;
}
.product-info {
  background: #e4e7e8;
}
</style>



// WEBPACK FOOTER //
// src/views/ApartmentType/ProductInApartmentType.vue